var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 157,
    viewBox: "0 0 143 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.7304 23.0703C90.3825 20.2757 89.3969 17.081 90.6626 14.2483C93.4874 7.92641 100.164 6.06722 104.729 5.55783C107.736 5.22227 110.637 6.47324 112.641 8.73963C125.168 22.9024 137.829 53.7718 137.049 88.9299C136.528 112.389 127.652 128.417 120.873 137.3C116.313 143.275 109.445 146.735 102.057 148.117C90.9855 150.187 72.9136 152.572 53.7403 150.99C45.8969 150.342 38.1182 148.335 31.4476 144.159C17.8386 135.638 8.2563 122.263 5.61352 103.279C4.66096 96.4369 8.30734 89.7384 14.9459 87.8263C16.2342 87.4554 17.6202 87.1238 19.0882 86.8646C24.412 85.9246 28.3981 90.6914 30.1067 95.8204C33.9797 107.448 44.738 114.832 55.316 111.669C57.4738 110.835 59.5707 109.575 61.4414 108.23C66.4782 104.607 68.6388 97.9374 65.8356 92.4028C60.7428 82.3466 50.337 77.9541 37.7149 81.2204C32.0279 82.6921 25.6916 82.0801 22.3335 77.26C21.6154 76.2295 20.8841 75.1075 20.1677 73.9037C16.0932 67.0553 18.7897 58.3 25.9578 54.8184C39.3091 48.3329 53.8398 48.964 67.7367 54.3254C62.1126 45.0183 55.2896 36.5249 47.2816 30.0147C44.0574 27.3933 41.4129 23.6602 42.3036 19.6011C43.5982 13.7003 47.521 9.93424 50.7722 7.74536C53.6812 5.78701 57.4018 5.98511 60.4808 7.66349C76.4106 16.3472 89.8078 31 97.4766 40.9017C96.1677 34.2969 94.1828 28.1561 91.7304 23.0703Z",
    stroke: "#1A6C65",
    strokeWidth: 10.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.31a3a92b7c2bc2d21fcee6ae7cd74e68.svg";
export { ForwardRef as ReactComponent };